export default "__VITE_ASSET__CJZYJ2as__"